const BackToTop = () => {
  return (
    <a href="#" className="back-to-top">
      <i className="far fa-angle-up" />
    </a>
  );
};
export default BackToTop;
